/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./utils/accordion.js');
require('./utils/ants.js');
require('./utils/btn-share.js');
require('./utils/console-logger.js');
require('./utils/cookie.js');
require("./utils/dark-mode.js");
require('./utils/fullscreen-content.js');
require('./utils/network-information.js');
require('./utils/qcm.js');
require('./utils/render-external-ico.js');
require('./utils/select2-prefectures.js');
require('./utils/synch-etg-exams.js');
require('./utils/toggle-password.js');
require('./utils/tooltip.js');
require('./utils/user-agent.js');

window.FontAwesomeConfig = {
  // autoReplaceSvg: false,
  searchPseudoElements: true
};

window.hasClass = (el, classname) => el && el.className && el.className.split(' ').indexOf(classname) >= 0;

window.parentWithClass = (el, classname) => {
  if (hasClass(el, classname)) {
    return el;
  }

  return el && el.parentNode && parentWithClass(el.parentNode, classname);
}

// window.utf8Decode = (s) => {
//   return s; // decodeURIComponent(escape(s));
// }

$.fn.isInViewport = function () {
  // var el = this;
  // var el = window;
  // if (window.namespace == 'admin' || window.namespace == 'customer') {
  //   el = '#page-content-wrapper';
  // }

  if (!$(this).length) {
    return false;
  }

  var elementTop = $(this).offset().top;
  if (elementTop == 0) {
    elementTop = $(this).parent().offset().top;
  }
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  // console.error('isInViewport', [elementTop, elementBottom, viewportTop, viewportBottom]);

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// @see analytics.blade.php
// window.dataLayer = window.dataLayer || [];
// window.gtag = (() => {
//     // console.info(arguments);
//     if (typeof dataLayer != 'undefined') {
//         dataLayer.push(arguments);
//     } else {
//         console.error('[google] dataLayer is undefined!', arguments);
//     }
// });

window.getScrollPercent = function () {
  var h = document.documentElement,
    b = document.body,
    st = 'scrollTop',
    sh = 'scrollHeight',
    percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

  // console.error('getScrollPercent', h[st], b[st], h[sh], b[sh], percent);
  percent = Math.round(percent);
  // console.error('getScrollPercent', $(document).scrollTop(), percent);

  if (isNaN(percent)) {
    percent = 0;
  }

  return percent;
}

window.scrollPublicHeader = function () {
  if ($(document).scrollTop() > 117) {
    $('#header-fixed-top').addClass('fixed-top');
  } else {
    // $('#.fixed-top').addClass('navbar-shrink');
    $('#header-fixed-top').removeClass('fixed-top');
  }

  var h = $('#header-fixed-top').height();
  h = Math.round(h);
  // $('#header-fixed-top ~ .container, #header-fixed-top ~ #sections').css({ 'padding-top': h, });
  // $('#header-fixed-top ~ .container-top, #header-fixed-top ~ #sections').css({ 'padding-top': h, });
}

window.scrollEditBar = function () {
  // $('#sections .public-rendered > div').each(function() {
  $('.edit-bar').parent().each(function () {
    var st = $(document).scrollTop()
    var tb = $(this).offset().top;
    var b = $(this).offset().top + $(this).parent().height() - 55;
    var t2 = st;

    var top = Math.max(tb, t2);
    top = Math.min(top, b);
    // top = Math.max(top, tb);
    top = Math.ceil(top); // + 10

    $(this).find('.edit-bar').css({ 'top': top });
  });
}

window.progressTimeBar = function () {
  var percent = window.getScrollPercent();
  $('.read-time-bar').css({ width: `${percent}%` });
}

window.pageOnScroll = () => {
  scrollPublicHeader();
  scrollEditBar();
  progressTimeBar();
}

$(window).on('scroll', () => {
  window.pageOnScroll();
});
$(() => {
  window.pageOnScroll();
});

$(() => {
  $('.form-date-with-slashes').keyup(e => {
    e.preventDefault();
    var pos = this.selectionStart;
    var keycode = e.which || e.keyCode;
    var $el = $(e.currentTarget);
    var val = $el.val();
    if (val) {
      if (keycode != 8) { // 8 = BACKSPACE
        val = val.replace(/^([0-9]{2})$/g, '$1/');
        val = val.replace(/^([0-9]+)\/([0-9]{2})$/g, '$1/$2/');
      }
      // console.error(pos, val, e.keyCode, KeyboardEvent.key);
      $el.val(val);

      if (!/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/g.test(val)) {
        $el.addClass('is-invalid');
      } else {
        $el.removeClass('is-invalid');
      }
    }
  });
});

window.navByAnchor = (() => {
  // Hash navigation
  let hash = window.location.hash;
  if (hash == '#/undefined' || hash == '#/') {
    hash = null;
  }
  // console.error('hash', hash, window.location.hash);

  // Tab anchor navigation (nav-tabs)
  $('.nav-tabs .nav-link').click(e => {
    e.preventDefault();

    let h = this.hash;
    if (!h && e.target) {
      h = $(e.target)[0].hash;
    }
    // console.error('h', h, hash, window.location.hash);
    if (h) {
      window.location.hash = h;
      // console.error('window.location.hash (1) =', window.location.hash);
    }
  });

  if (!hash) {
    $('.nav-tabs .nav-item .dropdown-menu a').click(e => {
      e.preventDefault();

      let h = this.hash;
      if (!h && e.target) {
        h = $(e.target)[0].hash;
      }
      // console.error('h', h, hash, window.location.hash);
      if (h) {
        window.location.hash = h;
        // console.error('window.location.hash (2) =', window.location.hash);
      } else {
        console.error(this)
      }
    });
  }

  if (hash == '#/') {
    return false;
  }

  if (hash) {
    let $el = $(`.nav-tabs .nav-link[href="${hash}"]`);
    if ($el.length) {
      if (typeof $el.tab != 'undefined') { // == 'function'
        $el.tab('show');
      } else {
        $('.nav-tabs .nav-link').removeClass('active');
        $el.addClass('active');
      }
    } else if (!$el.length) {
      let $el = $(`.nav-tabs .nav-item [href="${hash}"]`);
      if ($el.length) {
        if (typeof $el.tab != 'undefined') { // == 'function'
          $el.tab('show');
        } else {
          $('.nav-tabs .nav-link').removeClass('active');
          $el.parent().parent().find('.nav-link').addClass('active');
        }
      }
    } else if (!$el.length) {
      hash = hash.replace(/#\//, '#');
      $el = $(`.nav-tabs .nav-link[href="${hash}"]`);
      if ($el.length) {
        if (typeof $el.tab != 'undefined') {
          $el.tab('show');
        } else {
          $('.nav-tabs .nav-link').removeClass('active');
          $el.addClass('active');
        }
      }
    }

    // console.error(`.nav-tabs .nav-link[href="${hash}"]`, $(`.nav-tabs .nav-link[href="${hash}"]`));

  } else {

    // console.error(hash, `.nav-tabs .nav-link[href="${hash}"]`);

    $el = $('.nav-tabs .nav-link:first');
    if (typeof $el.tab != 'undefined') {
      $el.tab('show');
    } else {
      $('.nav-tabs .nav-link').removeClass('active');
      $el.addClass('active');
    }
    // console.error(`.nav-tabs .nav-link:first`);
  }

  return hash;
});

$(() => {
  navByAnchor();
});

if ("onhashchange" in window) {
  window.onhashchange = (() => {
    navByAnchor();
  });
}

// // //cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js
// // //cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js
// require('jquery.easing');

window.formatNumberToFr = (s) => {
  return s
    ? s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\./g, ',')
    : s;
}

window.formatPrice = (price, currency = 'eur', digits = 2) => {

  let symbol = '€';

  if (currency == 'eur') {
    symbol = '€';
  } else if (currency == 'percent') {
    symbol = '%';
  }

  if (digits === 0) {
    digits = '';
  }
  // if (typeof digits == 'undefined') {
  //   digits = 2;
  // }

  return parseFloat(price).toFixed(digits).toString().replace(".", ",") + '&#8239;' + symbol;
}

window.copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

window.linkify = (inputText) => {
  var s, p1, p2, p3;

  // URLs starting with http://, https://, or ftp://
  p1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  s = inputText.replace(p1, '<a href="$1" target="_blank">$1</a>');

  // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  p2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  s = s.replace(p2, '$1<a href="http://$2" target="_blank">$2</a>');

  // Change email addresses to mailto:: links.
  p3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  s = s.replace(p3, '<a href="mailto:$1">$1</a>');

  return s;
}

window.autodate = ((selector) => {
  $(selector).on('keyup', function (e) {
    var k = e.which;
    if (k == 8 || k == 37 || k == 39 || k == 46) { // Backspace, arrows, delete
      return false;
    }
    var v = $(this).val().replace(/[^0-9\/]+/g, '');
    if (v.match(/^\d{1}\//)) {
      v = '0' + v;
    }
    if (v.match(/^\d{2}\/\d{1}\//)) {
      v = v.replace(/^(\d{2})\/(\d{1})\//, '$1/0$2/');
    }
    if (v.match(/^\d{2}$/) !== null || v.match(/^\d{2}\/\d{2}$/) !== null) {
      v += '/';
    }
    for (var l of [2, 5]) {
      if (v.length >= l && v[l] != '/') {
        v = v.substring(0, l) + '/' + v.substring(l);
      }
    }
    v = v.replace(/\/\//, '/');
    window.$(this).val(v);
  });
});

window.autotab = ((selector) => {
  $(selector).on('keyup', function (e) {
    var $this = $(this);
    var k = e.which;
    if (!$this.val() && k == 8) { // Backspace
      var $previous = $this.prevAll(`${selector}[value=''], ${selector}:not([value])`)[0];
      if ($previous) {
        $previous.focus();
        // if (typeof $previous.val != 'undefined') {
        //   $previous.val($previous.val());
        // }

        return false;
      }
    }
    var ml = $this.attr('maxlength');
    ml = parseInt(ml, 10);
    var l = $this.val().length;
    if (l >= ml) {
      var $next = $this.nextAll(`${selector}[value=''], ${selector}:not([value])`)[0];
      if ($next) {
        $next.focus();
      }
    }
  });
});

// TODO Set scroll with #page-content-wrapper
window.scrollTo = (target, scrollable, ymod) => {
  setTimeout(() => {
    if ($(target).length) {
      var top = $(target).offset().top;
      if (!top && target.indexOf('#') === 0) {
        top = $(`[for=${target.substr(1)}]`).offset()
          ? $(`[for=${target.substr(1)}]`).offset().top
          : null;
      }
      if (!top) {
        top = $(target).parent().offset().top;
      }
      top = Math.round(top);
      if (!scrollable && typeof $(target).isInViewport != 'undefined'
        && $(target).isInViewport()) {
        // console.error('scrollTo Not in viewport');

        return false;
      }

      var el = 'html, body';
      if (window.namespace == 'admin' || window.namespace == 'customer') {
        el = '#page-content-wrapper';
      }
      if (scrollable) {
        el = scrollable;
        top -= $(scrollable).offset().top;
      }
      if (typeof ymod != 'undefined') {
        top += ymod;
      }
      $(el).stop().animate({
        scrollTop: top - 75
        // }, 500, 'easeInOutExpo'); // $.easing
      }, 500, 'easeOutQuart');

      // console.error('scrollTo', top);

    } else {
      console.error('scrollTo Target not found', target);
    }
  }, 100);

  return true;
};

let pageScrollId = null;
let updatePageScroll = (() => {
  let n = 0;
  $('.page-scroll').each(() => {
    if (!$(this).data('scrollable')) {
      console.error('updatePageScroll')
      console.error($(this));
      $(this).bind('click', (event) => {
        var $anchor = $(this);
        var target = $anchor.attr('href');
        if ($anchor.data('href')) {
          target = $anchor.data('href');
        }
        var ymod = null;
        if ($anchor.data('ymod')) {
          ymod = $anchor.data('ymod');
        }
        console.error('scrollTo', target, ymod);
        scrollTo(target, null, ymod);
        event.preventDefault();
      });
      $(this).data('scrollable', '1');
      n++;
    }
  });
  clearTimeout(pageScrollId);
  pageScrollId = setTimeout(updatePageScroll, 200);

  return true;
});

window.updatePageScroll = updatePageScroll;

$(() => {
  updatePageScroll();
});

// Redraw Lavacharts
// lava.ready(function () {});
let oldWrapperWidth = $('#wrapper').width();
$(() => {
  setInterval(() => {
    if (typeof lava != 'undefined' && oldWrapperWidth != $('#wrapper').width()) {
      for (var z in lava._charts) {
        if (lava._charts[z].chart) {
          lava._charts[z].redraw();
        }
      }
      oldWrapperWidth = $('#wrapper').width();
    }
  }, 250);
});

// Right click on video
// setInterval(() => {
//   // Mutator
//   $('video').bind('contextmenu', (e) => {
//     return false;
//   });
// }, 500);

window.getSidebarWidthCurrent = () => {
  return parseInt($('#sidebar-wrapper').width() ? $('#sidebar-wrapper').width() : 0);
}

// @see Mutator
setInterval(() => {
  var sidebarWidthCurrent = getSidebarWidthCurrent();
  document.documentElement.style.setProperty('--sidebar-width-current', sidebarWidthCurrent + 'px');
  document.documentElement.style.setProperty('--sidebar-width-current-integer', sidebarWidthCurrent);
}, 10);

var Mutator = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
const observer = new Mutator(list => {
  tooltip();
  scrollEditBar();
  progressTimeBar();
  $('video').bind('contextmenu', (e) => {
    return false;
  });
  activateFullscreenImgs();

  document.documentElement.style.setProperty('--inner-width', `${window.innerWidth}px`);
  document.documentElement.style.setProperty('--inner-height', `${window.innerHeight}px`);

  var sidebarWidthCurrent = getSidebarWidthCurrent();
  document.documentElement.style.setProperty('--sidebar-width-current', sidebarWidthCurrent + 'px');
  document.documentElement.style.setProperty('--sidebar-width-current-integer', sidebarWidthCurrent);
});

observer.observe(document.body, { attributes: true, childList: true, subtree: true });

// debug-sidebar
// window.debugSideBar = () => {
//   $('#debug--inner-width').html(window.innerWidth);
//   $('#debug--inner-height').html(window.innerHeight);
//   $('#debug--sidebar-width-current').html(parseInt($('#sidebar-wrapper').width() ? $('#sidebar-wrapper').width() : 0));
// }